<template>
  <v-container fluid>
    <v-card>
      <v-snackbar
        :timeout="30000"
        :top="true"
        :color="toastColor"
        v-model="toastEnable"
      >
        {{ toastText }}
        <v-btn dark flat @click.stop="toastEnable = false"
          ><v-icon>close</v-icon></v-btn
        >
      </v-snackbar>
    </v-card>

    <v-tabs color="transparent" v-model="tab" show-arrows>
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab v-for="tabItem in tabs" :key="tabItem">
        {{ tabItem }}
      </v-tab>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item v-for="(item, index) in 2" :key="'item' + index">
          <div v-if="tab === 0 && index === 0">
            <UpcMainTabItem
              @showToast="showToast"
              @showAddUpcDialog="showAddUpcDialog"
            />
          </div>
          <div v-if="tab === 1 && index === 1">
            <PricingPlan/>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <InboundAddUpcPopup
      v-if="addUpcDialog"
      v-model="addUpcDialog"
      hasMultiple
    />
  </v-container>
</template>

<script>
import UpcMainTabItem from './UpcMainTabItem'
import InboundAddUpcPopup from './InboundAddUpcPopup'
import PricingPlan from './PricingPlan'

export default {
  name: 'Upc',
  components: {
    UpcMainTabItem,
    InboundAddUpcPopup,
    PricingPlan
  },
  data () {
    return {
      toastColor: 'error',
      toastEnable: false,
      toastText: '',
      toastMsgs: [],
      addUpcDialog: false,
      tabs: [this.$t('upc'), this.$t('pricingPlan')],
      tab: 0
    }
  },
  methods: {
    showToast (e) {
      Object.assign(this, e)
    },
    showAddUpcDialog () {
      this.addUpcDialog = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Upc.vue